export function parseEvalSetDisplayNames(
  raw: string | undefined
): Readonly<Record<string, string>> {
  const names: Record<string, string> = Object.create(null);
  if (!raw?.trim()) return Object.freeze(names);

  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    throw new Error('VITE_EVAL_SET_DISPLAY_NAMES must contain valid JSON');
  }
  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    throw new Error(
      'VITE_EVAL_SET_DISPLAY_NAMES must be an object mapping collection IDs to display names'
    );
  }
  const seen = new Set<string>();
  for (const [id, name] of Object.entries(parsed)) {
    if (!id.trim() || typeof name !== 'string' || !name.trim()) {
      throw new Error(
        'VITE_EVAL_SET_DISPLAY_NAMES requires nonempty IDs and string display names'
      );
    }
    const normalized = name.trim().toLowerCase();
    if (seen.has(normalized)) {
      throw new Error(
        'VITE_EVAL_SET_DISPLAY_NAMES display names must be unique (case-insensitive)'
      );
    }
    seen.add(normalized);
    names[id] = name.trim();
  }
  return Object.freeze(names);
}
